import React from 'react';
import ProductCard from '../ProductCardList/ProductCard/ProductCard';
import { ProductCardContent } from '../ProductCardList/ProductCard/ProductCardContent';
import { SelectableWrapper } from './SelectableWrapper';
import { SelectedIcon } from './SelectedIcon';
export const SelectableProductCard = ({ onSelect, isDisabled, children, isSelected, dataHook, renderWrapper, ...props }) => {
    const handleSelect = () => {
        if (!isDisabled) {
            onSelect();
        }
    };
    const wrapperBorderRadius = typeof props.borderRadius === 'string'
        ? `${parseInt(props.borderRadius, 10) + 2}px`
        : `${(props.borderRadius ?? 0) + 2}px`;
    const wrapperElement = renderWrapper?.({ isSelected }) ?? (React.createElement(SelectableWrapper, { borderColor: isSelected ? '#116DFF' : 'transparent', borderWidth: "2px", borderRadius: wrapperBorderRadius, selectedIcon: React.createElement(SelectedIcon, null) }));
    const wrappedCard = React.cloneElement(wrapperElement, {
        dataHook,
        style: { cursor: 'pointer' },
        selectedIcon: isSelected ? wrapperElement.props.selectedIcon : undefined,
    }, React.createElement(ProductCard, { ...props }, children));
    return (React.createElement("div", { onClick: handleSelect, "data-hook": "click-handler", style: { width: props.width } }, wrappedCard));
};
SelectableProductCard.Tag = ProductCard.Tag;
SelectableProductCard.Header = ProductCard.Header;
SelectableProductCard.Separator = ProductCard.Separator;
SelectableProductCard.FeatureList = ProductCard.FeatureList;
SelectableProductCard.Price = ProductCard.Price;
SelectableProductCard.Content = ProductCardContent;
//# sourceMappingURL=SelectableProductCard.js.map